import { useEventTags } from '../../hooks/useEventTags'

interface AttributeCheckboxGridProps {
  /** Current attribute flags keyed by tag slug. */
  attributes: Record<string, boolean | undefined>
  onToggle: (slug: string, checked: boolean) => void
}

// Shared attribute (dietary / audience) checkbox grid used by the person event
// create and edit forms. Tag list comes from the admin-managed API, so adding or
// renaming a tag from the super admin page updates both forms automatically.
export function AttributeCheckboxGrid({ attributes, onToggle }: AttributeCheckboxGridProps) {
  const { data: tags, isLoading } = useEventTags()

  if (isLoading) {
    return <div className="text-[13px] text-muted">Loading attributes…</div>
  }
  if (!tags?.length) {
    return <div className="text-[13px] text-muted">No attributes available.</div>
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      {tags.map((tag) => {
        const checked = Boolean(attributes[tag.slug])
        return (
          <label
            key={tag.slug}
            className={`flex items-center gap-2.5 px-3 py-2.5 rounded-[10px] cursor-pointer border-[1.5px] ${checked ? 'bg-primary-soft border-primary' : 'bg-s2 border-line-soft'}`}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => onToggle(tag.slug, e.target.checked)}
              aria-label={tag.label}
              className="w-[15px] h-[15px] accent-primary cursor-pointer shrink-0"
            />
            <span className="text-[13px] font-medium">{tag.label}</span>
          </label>
        )
      })}
    </div>
  )
}
